import {
  SelectMediaConfig,
  SelectMediaConfigButton,
  SelectMediaConfigEmptyState,
} from '@cohort/merchants/apps/common/triggers/SelectMedia/SelectMediaConfig';
import {SelectMediaContextProvider} from '@cohort/merchants/apps/common/triggers/SelectMedia/SelectMediaContextProvider';
import InstagramMediaCard from '@cohort/merchants/apps/instagram/triggerIntegrations/components/InstagramMediaCard';
import SelectPostSheet from '@cohort/merchants/apps/instagram/triggerIntegrations/components/SelectPostSheet';
import type {InstagramMedia} from '@cohort/shared/apps/instagram/common';
import {Fragment} from 'react/jsx-runtime';

type InstagramMediaSelectorProps = {
  description: string;
  onSelectMedia: (mediaId: string) => void;
  title: string;
  medias: InstagramMedia[];
  selectedMedia?: InstagramMedia;
};

const InstagramMediaSelector: React.FC<InstagramMediaSelectorProps> = ({
  description,
  onSelectMedia,
  selectedMedia,
  title,
  medias,
}) => (
  <SelectMediaContextProvider defaultMediaId={selectedMedia?.id ?? null}>
    <SelectMediaConfig title={title} description={description}>
      {selectedMedia === undefined ? (
        <Fragment>
          <SelectMediaConfigEmptyState />
          <SelectMediaConfigButton mode="add" />
        </Fragment>
      ) : (
        <Fragment>
          <InstagramMediaCard media={selectedMedia} />
          <SelectMediaConfigButton mode="change" />
        </Fragment>
      )}
      <SelectPostSheet onSelectMedia={onSelectMedia} medias={medias} />
    </SelectMediaConfig>
  </SelectMediaContextProvider>
);

export default InstagramMediaSelector;
